var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.06 38.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5e68ec;}.cls-2{fill:#191d21;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "emailLogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-0.39,5025.32h0a19,19,0,0,1-19-19,19,19,0,0,1,19-19,19,19,0,0,1,19,19A19,19,0,0,1-.39,5025.32Z",
    transform: "translate(19.42 -4987.26)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.93,5014.07v-1H-9.7a0.67,0.67,0,0,1-.67-0.67v-12.21a0.67,0.67,0,0,1,.67-0.67H8.93a0.67,0.67,0,0,1,.67.67v12.21a0.67,0.67,0,0,1-.67.67v2a2.67,2.67,0,0,0,2.67-2.67v-12.21a2.67,2.67,0,0,0-2.67-2.67H-9.7a2.67,2.67,0,0,0-2.67,2.67v12.21a2.67,2.67,0,0,0,2.67,2.67H8.93v-1Z",
    transform: "translate(19.42 -4987.26)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-12,5002.33l9,7.11,0.09,0a5.58,5.58,0,0,0,2.54.61,5.59,5.59,0,0,0,2.53-.61l0.09,0,9-7.1L10,5000.76l-8.91,7,0.62,0.78-0.45-.89a3.58,3.58,0,0,1-1.63.39A3.59,3.59,0,0,1-2,5007.7l-0.45.89,0.62-.78-8.91-7Z",
    transform: "translate(19.42 -4987.26)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogo);
export default __webpack_public_path__ + "static/media/emailLogo.f2bcc4399473fbf720161b0b326fc120.svg";
export { ForwardRef as ReactComponent };